import { PrimaryTableColumn } from "@hatch-digital-nl/abs-storybook/legacy";

interface Props {
    isEstablishmentManager?: boolean;
}

export const getExpiredTableColumns = (props: Props): PrimaryTableColumn[] => {
    const { isEstablishmentManager } = props;

    return [
        {
            value: "Certificaat",
            isSortable: false,
        },
        ...(isEstablishmentManager
            ? [
                  {
                      value: "Naam",
                      isSortable: false,
                      isBold: true,
                  },
                  {
                      value: "Norm",
                      isTag: true,
                      tagColor: "#FFFFFF",
                      tagBackgroundColor: "#07A9D6",
                  },
                  {
                      value: "Opleider",
                      isSortable: false,
                  },
              ]
            : []),
        {
            value: "Verlopen op",
            isSortable: false,
        },
    ];
};
